export default __webpack_public_path__ + "static/media/usdxxLogo.86282f8c.png";